export class DatiCatastaliTerreniExtra {
  id: string;
  superficie: string;
  unitaMisura: string;
  redditoAgrario: any;
  redditoDominicale: any;
  qualita: string;
}
